<div class="card-block" style="margin: 10px;">
    <div class="row">
        <div class="col-md-12">
            <span class="listHeaderText">Vault Ledger</span>
        </div>
        <div class="main-field">
            <div class="main-block-content">
                <div class="row d-flex  mt-1">
                    <div class=" d-flex col-md-12 col-lg-12">
                        <label>Ledger Of: Company</label>
                        <p-inputSwitch [(ngModel)]="isUserLedger" name="Ledger For" (onChange)="toggleLedgerFor($event)"
                            class="pl-2 pr-2"></p-inputSwitch>
                        User

                        <ng-select class="col-sm-12 col-md-6 col-lg-6" *ngIf="isUserLedger"
                            [(ngModel)]="ledgerRequestObj.accountId" (change)="setSelectedUser($event);">
                            <ng-option value="">Select User</ng-option>
                            <ng-option *ngFor="let user of userList" [value]="user.accountId">{{user.name}}</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="row d-flex  mt-3">
                    <div class=" d-flex col-md-12 col-lg-12">
                        <label for="fromDate">From Date:</label>
                        <p-calendar id="fromDate" [(ngModel)]="ledgerRequestObj.fromDate" dateFormat="dd/mm/yy"
                            class="pl-2 pr-2" [showIcon]="true" inputId="buttondisplay"
                            [showOnFocus]="false"></p-calendar>

                        <label for="toDate">To Date:</label>
                        <p-calendar id="toDate" [(ngModel)]="ledgerRequestObj.toDate" dateFormat="dd/mm/yy"
                            class="pl-2 pr-2" [showIcon]="true" inputId="buttondisplay"
                            [showOnFocus]="false"></p-calendar>

                        <button pButton type="button" label="Get Ledger" (click)="getLedgerViewData()"
                            class="ml-2"></button>
                    </div>
                </div>


                <div class="row mt-1">
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="openingBalance">Opening Balance: ₹ {{ledgerViewData?.openingBalance |
                            indianCurrency}}</label>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <label for="closingBalance">Closing Balance: ₹ {{ledgerViewData?.closingBalance |
                            indianCurrency}}</label>
                    </div>
                </div>

            </div>
        </div>
        <div class="col xs-12 col-md-12 col-lg-12" style="height: 500px; margin: 10px;">
            <app-common-table [columnDefs]="columnDefs" [data]="ledgerViewData?.ledgerRows" [enableRowStyles]="false">
            </app-common-table>
        </div>
    </div>
</div>